module.exports = __webpack_public_path__ + "static/media/logo-c.e4134d2e.svg";